import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { useDestroyReportUser, useUpdateReportUser } from 'api/hooks/use-report-user'
import { useQueryClient } from 'react-query'
import MutedText from 'shared/forms/muted-text'

function ReportUserRow({ reportUser, editable, reportId }) {
  const queryClient = useQueryClient()
  const [isEditor, setIsEditor] = useState(reportUser.is_editor || false)

  const options = {
    onSuccess: () => {
      queryClient.invalidateQueries([`reports/${reportId}`])
      queryClient.invalidateQueries('reports-builder')
    }
  }

  const { mutate: destroyMutation, isLoading: isDestroying } = useDestroyReportUser({
    id: reportUser.id,
    options
  })

  const { mutate: updateMutation, isLoading: isUpdating } = useUpdateReportUser({
    id: reportUser.id,
    options: {
      ...options,
      onSuccess: (data) => {
        if (data && data.is_editor !== undefined) {
          setIsEditor(data.is_editor)
        }
        options.onSuccess()
      }
    }
  })

  const handleRoleChange = (e) => {
    updateMutation({ is_editor: e.target.value === 'editor' })
  }

  return (
    <tr>
      <td>
        <div className="d-flex align-items-center justify-content-between gap-2">
          <div>
            {reportUser.first_name} {reportUser.last_name}
            <MutedText as="div">
              <small>{reportUser.email}</small>
            </MutedText>
          </div>
          {editable && (
            <Form.Select
              size="sm"
              id={`editor-select-${reportUser.id}`}
              aria-label="Access role"
              value={isEditor ? 'editor' : 'viewer'}
              onChange={handleRoleChange}
              disabled={isUpdating || isDestroying}
              style={{ width: 'auto' }}
            >
              <option value="viewer">Viewer</option>
              <option value="editor">Editor</option>
            </Form.Select>
          )}
        </div>
      </td>
      <td className="text-end border-bottom-0">
        {editable && (
          <Button
            variant="light"
            className="bg-light"
            onClick={() => destroyMutation()}
            disabled={isDestroying || isUpdating}
          >
            <FontAwesomeIcon icon={faTrash} className="text-danger" />
          </Button>
        )}
      </td>
    </tr>
  )
}

export default ReportUserRow
